import { Component, OnInit } from "@angular/core";
import { DialogService } from "primeng/dynamicdialog";
import { UserService } from "../../../shared";
import { FacilityService } from "../../../shared/services/facility.service";
import { SchoolselectorService } from "../../schoolselector/schoolselectorservice.service";
import { MergeToGroupDialogComponent } from "../merge-to-group-dialog/merge-to-group-dialog.component";
import { ReportService } from "../report.service";
import { MergeToGroupRequest } from "../report-services/merge-to-group-request";
import { VisitorTypeService } from "../report-services/visitor-type.service";

@Component({
	selector: "app-visitor-block-list",
	templateUrl: "./visitor-block-list.component.html",
	styleUrls: ["./visitor-block-list.component.css"],
})
export class VisitorBlockListComponent implements OnInit {
	constructor(
		private selectService: SchoolselectorService,
		private reportService: ReportService,
		//Insert Custom Services Here
		private visitortypeService: VisitorTypeService,
		private facilityService: FacilityService,
		private dialogService: DialogService,
		private userService: UserService
	) {}

	report = {
		SchoolID: 0,
		//Insert Custom Parameters Here
		FacilityID: 0,
		StartDate: new Date(),
		EndDate: new Date(),
		VisitorTypeID: 0,
		ORDERBYID: "FirstName",
		ImageLogo: "",
	};

	SchoolSelectShowAllID: any = 0;
	SchoolSelectShowAllText: any = "All Schools";

	//Insert Custom Lists Here
	FacilityList: any = [];
	VisitorTypeList: any = [];
	ImageLogoList: any = [];

	OutputTypeID: any = 1;
	OutputTypeList = [
		{
			ID: 1,
			Desc: ".PDF",
		},
		// {
		//     ID: 2,
		//     Desc: ".Doc (Word Document)" //Doesn't seem to work
		// },
		// {
		//     ID: 3,
		//     Desc: ".xls (Excel file)" //Ending Support for xls, just use CSV
		// },
		{
			ID: 4,
			Desc: ".CSV (Excel file)",
		},
		{
			ID: 5,
			Desc: ".RTF (Rich Text File)",
		},
		// {
		//     ID: 6,
		//     Desc: ".XML" //Doesn't seem to work
		// },
		{
			ID: 7,
			Desc: ".HTM (Web Page)",
		},
		// {
		//     ID: 8,
		//     Desc: ".rpt" //Doesn't seem to work
		// },
		// {
		//     ID: 9,
		//     Desc: ".grp" //Doesn't seem to work
		// }
	];

	ORDERBYList: any = [
		{
			ID: "FirstName",
			Desc: "First Name",
		},
		{
			ID: "LastName",
			Desc: "Last Name",
		},
		{
			ID: "Offender",
			Desc: "Offender Status",
		},
	];

	ReportID: number = 444;

	subscription: any;
	user: any;
	errorMessage: any = "";
	isProcessing: any = false;

	ngOnInit() {
		//Insert Custom Init Methods Here
		this.user = this.userService.getCurrentUser();

		this.subscription = this.selectService.onSchoolChanged().subscribe((school) => {
			// this.SchoolID = school.SchoolID;
			this.onSchoolChange(school.SchoolID);
		});

		this.loadVisitorTypeList();
	}

	ngOnDestroy() {
		this.subscription.unsubscribe();
	}

	onSchoolChange(val) {
		this.report.SchoolID = val;

		this.loadFacilityList();
		this.loadLogolist();
	}

	private loadFacilityList() {
		this.report.FacilityID = 0;
		var result = this.facilityService.loadFacilityRPTList(0, this.report.SchoolID);
		result.subscribe(
			(response) => {
				this.FacilityList = response;

				this.FacilityList.unshift({
					FacilityID: 0,
					FacilityName: "All Facilities",
				});

				this.report.FacilityID = this.FacilityList[0].FacilityID;
			},
			(error) => {}
		);
	}

	private loadVisitorTypeList() {
		this.report.VisitorTypeID = 0;
		var result = this.visitortypeService.loadVisitorTypeList(0, this.report.SchoolID);
		result.subscribe(
			(response) => {
				this.VisitorTypeList = response;

				// this.VisitorTypeList.unshift({
				//   VisitorTypeID: 0,
				//   VisitorTypeDesc: "All Visitor Types"
				// })

				this.report.VisitorTypeID = this.VisitorTypeList[0].VisitorTypeID;
			},
			(error) => {}
		);
	}

	private loadLogolist() {
		var result = this.reportService.ImageLogoGetList("", this.report.SchoolID);
		result.subscribe(
			(response) => {
				this.ImageLogoList = response;

				this.report.ImageLogo = this.ImageLogoList[0].ImageLibraryID;
			},
			(error) => {}
		);
	}

	Print() {
		var component = this;
		this.errorMessage = "";

		//Insert Custom Error Checks Here
		// if (!this.report.FacilityID) {
		// 	this.errorMessage = "Select the Facility"
		// 	return;
		// }

		// if (!this.report.StartDate) {
		// 	this.errorMessage = "Select the StartDate"
		// 	return;
		// }

		// if (!this.report.EndDate) {
		// 	this.errorMessage = "Select the EndDate"
		// 	return;
		// }

		// if (!this.report.VisitorTypeID) {
		// 	this.errorMessage = "Select the VisitorType"
		// 	return;
		// }

		// if (!this.report.UserID) {
		// 	this.errorMessage = "Select the User"
		// 	return;
		// }

		var strParam = this.GetStrParam();
		this.isProcessing = true;

		var result = this.reportService.Print(this.ReportID, strParam, this.report.SchoolID, this.OutputTypeID);

		result.subscribe(
			(response: any) => {
				component.isProcessing = false;
				window.open(response);
			},
			(error) => {
				component.errorMessage = error;
				component.isProcessing = false;
			}
		);
	}

	GetStrParam(): string {
		var strParam: string = "";

		//Parameter 1: SchoolID
		strParam += this.report.SchoolID + "|SchoolID";

		//Parameter 2: FacilityID
		strParam += "," + this.report.FacilityID + "|FacilityID";

		//Parameter 3: VisitorTypeID
		strParam += "," + this.report.VisitorTypeID + "|VisitorTypeID";

		//Parameter 4: UserID
		strParam += "," + this.user.userID + "|UserID";

		//Parameter 5: ORDERBY
		strParam += "," + this.report.ORDERBYID + "|ORDERBY";

		//Parameter 6: ImageLogo
		strParam += "," + this.report.ImageLogo + "|Imagelogo";

		return strParam;
	}

	MergeToGroup() {
		this.errorMessage = "";

		this.isProcessing = true;
		var strParam = this.GetStrParam();

		var parms: MergeToGroupRequest = {
			ReportID: this.ReportID,
			SchoolID: this.report.SchoolID,
			strParms: strParam,
		};

		var result = this.reportService.MergeToGroupSelectInfo(parms);
		result.subscribe(
			(response: any) => {
				if (response.length > 0) {
					var ref = this.dialogService.open(MergeToGroupDialogComponent, {
						header: "Merge to Group",
						width: "fit-content",
						data: {
							//INSERT Custom Data here
							lstPerson: response,
							SchoolID: this.report.SchoolID,
						},
					});
					ref.onClose.subscribe((response) => {
						if (response == 1) {
						}
					});
				} else {
					this.errorMessage = "No Data available";
				}

				this.isProcessing = false;
			},
			(error) => {
				this.errorMessage = error;
				this.isProcessing = false;
			}
		);
	}
}
